import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomJwtAuthService {

  constructor(private http: HttpClient) {}

  createCustomJwt(tenantId:string, uid:string): Observable<string> {
    return this.http.post(`${environment.api.customJwtUrl}?cacheBuster=${new Date().getTime()}`,
      {
        uid,
        tenantId
      })
      .pipe(
        tap(response => console.log(`Response to createCustomJwt: ${JSON.stringify(response)}`)),
        map(res => res['customJWt'])
      );
  }

}
